/**
 * Indicates the trade is a result of an offset or onset.
 * tag: 1849
 * @readonly
 * @enum {number} (int)
 */
export enum OffsetInstruction {
  Offset = 0,
  Onset = 1,
}
